import script from "./CentralAreaRemunerationBP.vue?vue&type=script&setup=true&lang=ts"
export * from "./CentralAreaRemunerationBP.vue?vue&type=script&setup=true&lang=ts"

import "./CentralAreaRemunerationBP.vue?vue&type=style&index=0&id=6075b0a6&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6075b0a6"]])

export default __exports__